import { configureStore, combineReducers } from '@reduxjs/toolkit'

import authenticationReducer from './authentication/slice'
import clubReducer from './club/slice'
import clubsReducer from './clubs/slice'
import countriesReducer from './countries/slice'
import countryStatesReducer from './countryStates/slice'
import courseReducer from './course/slice'
import coursesReducer from './courses/slice'
import localeReducer from './locale/slice'
import challengeReducer from './challenge/slice'
import challengesReducer from './challenges/slice'
import challengeTypesReducer from './challengeTypes/slice'
import challengesMediaReducer from './challengesMedia/slice'
import userChallengeReducer from './userChallenge/slice'
import userChallengesReducer from './userChallenges/slice'
import leaderboardReducer from './leaderboard/slice'
import participantRoundsReducer from './participantRounds/slice'
import cognitoUserReducer from './cognitoUser/slice'

import routeReducer from './route/slice'
import userReducer from './user/slice'
import usersReducer from './users/slice'
import adminsReducer from './administrators/slice'
import gameReducer from './game/slice'
import gamesReducer from './games/slice'
import providersReducer from './providers/slice'
import privilegesReducer from './privileges/slice'
import timeZonesReducer from './timeZones/slice'
import { logoutMiddleware } from './logoutMiddleware'
import { useDispatch } from 'react-redux'
import leaderboardsReducer from './leaderboards/slice'

const reducer = combineReducers({
  administrators: adminsReducer,
  authentication: authenticationReducer,
  club: clubReducer,
  clubs: clubsReducer,
  countries: countriesReducer,
  course: courseReducer,
  courses: coursesReducer,
  challenge: challengeReducer,
  challenges: challengesReducer,
  challengeTypes: challengeTypesReducer,
  challengesMedia: challengesMediaReducer,
  countryStates: countryStatesReducer,
  game: gameReducer,
  games: gamesReducer,
  leaderboard: leaderboardReducer,
  leaderboards: leaderboardsReducer,
  locale: localeReducer,
  participantRounds: participantRoundsReducer,
  providers: providersReducer,
  privileges: privilegesReducer,
  route: routeReducer,
  timeZones: timeZonesReducer,
  user: userReducer,
  users: usersReducer,
  userChallenge: userChallengeReducer,
  userChallenges: userChallengesReducer,
  cognitoUsers: cognitoUserReducer,
})

export type RootState = ReturnType<typeof reducer>

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logoutMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
})

export default store

type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
